var __rspack_ns_object = JSON.parse('{"yofrive":"友福到"}')